/* eslint-disable */

import React from "react";
import { renderReact } from "../src/lib/ssrHydrator";
import ArticleSearchContainer from "../src/ArticleSearchForm/containers/ArticleSearchContainer";
import { CompanyPCArticleListWrapper } from "./CompanyPCArticleList";
import { OnlyPager } from "../src/ArticleSearchForm/components/shared/pc/PagingZone";
import ErrorBoundary from "../src/ErrorBoundary/error_notifier";
import { buildTotalPages } from "../src/utils/search";

function CompanyPCArticleListWithPager(props) {
  const { response, page, location_path, company_name, company_name_ja } =
    props;
  const totalPages = buildTotalPages(response.hits.total.value);
  return (
    <ErrorBoundary>
      <ArticleSearchContainer.Provider
        initialState={{ ...props, requestFromSp: false }}
      >
        <OnlyPager
          totalPages={totalPages}
          page={page}
          locationPath={location_path}
        />
        <OnlyPager
          totalPages={totalPages}
          page={page}
          locationPath={location_path}
        >
          <CompanyPCArticleListWrapper
            company_name={company_name}
            company_name_ja={company_name_ja}
          />
        </OnlyPager>
      </ArticleSearchContainer.Provider>
    </ErrorBoundary>
  );
}

export default renderReact(
  "CompanyPCArticleListWithPager",
  CompanyPCArticleListWithPager
);
